// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { color } from "@hardwoods/XDL/Utilities";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { HiddenProps } from "@insite/mobius/Hidden";
import { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

interface MyAccountsDetailsHeaderStyle {
    titleText?: TypographyProps;
    buttonsHiddenContainer?: HiddenProps;
    menuHiddenContainer?: HiddenProps;
    headerGridContainer?: GridContainerProps;
    buttonStyle?: InjectableCss;
}

export const myAccountsDetailsHeaderStyle: MyAccountsDetailsHeaderStyle = {
    headerGridContainer: {
        gap: 5,
    },
    titleText: {
        css: css`
            margin: 0;
            @media print {
                font-size: 36px !important;
            }
        `,
        variant: "h2",
        as: "h1",
    },
    buttonsHiddenContainer: {
        below: "lg",
        css: css`
            margin: 0;
            display: flex;
            justify-content: flex-end;
            align-items: center;
        `,
    },
    menuHiddenContainer: {
        css: css`
            margin: 0;
            align-items: center;
        `,
        above: "md",
    },
    buttonStyle: {
        css: css`
            &:focus {
                outline: none;
                box-shadow: 0 0 8px 0 ${color("secondary")};
            }
        `,
    },
};
